import { AutoAwesome } from '@mui/icons-material';
import { Box, Paper, Stack, Typography } from '@mui/material';
import useAppTheme from 'hooks/useAppTheme';
import { useTranslation } from 'react-i18next';

const deltaColorMap = {
  red: {
    color: '#EF4444',
    borderColor: 'rgba(239, 68, 68,0.9)',
  },
  green: {
    color: '#22C55E',
    borderColor: 'rgba(34, 197, 94, 0.6)',
  },
  grey: {
    color: '#9CA3AF',
    borderColor: 'rgba(107, 114, 128, 0.4)',
  },
  white: {
    color: '#FFFFFF',
    borderColor: 'rgba(255, 255, 255, 0.4)',
  },
};

export const FleetKPICard = ({
  icon: Icon,
  label,
  planValue,
  planUnit,
  actualValue,
  actualUnit,
  delta,
  deltaType,
}: {
  icon: React.ElementType;
  label: string;
  planValue: string | number;
  planUnit: string;
  actualValue: string | number;
  actualUnit: string;
  delta: string;
  deltaType: string;
}) => {
  const { t } = useTranslation();
  const deltaColor =
    deltaColorMap[deltaType as keyof typeof deltaColorMap] ||
    deltaColorMap.grey;

  const { enableDarkTheme } = useAppTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        p: 1.7,
        borderRadius: 2,
        border: `1px solid ${deltaColor.borderColor}`,
        // background: 'default.paper',
      }}
    >
      <Stack spacing={1}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ color: 'text.secondary' }}
        >
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{ color: deltaColor.color }}
          >
            <Icon fontSize="small" />
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: '0.9rem',
              }}
            >
              {label}
            </Typography>
          </Stack>
        </Stack>

        <Box>
          <Box display={'flex'} alignItems={'end'} gap={'0px'}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: '1.8rem',
                color: 'text.primary',
                lineHeight: 1,
              }}
            >
              {actualValue}
            </Typography>
            <Typography
              sx={{ fontSize: '0.8rem', ml: 0.3, color: 'text.secondary' }}
            >
              {actualUnit}
            </Typography>
          </Box>

          <Typography
            sx={{
              color: deltaColor.color,
              fontWeight: 600,
              fontSize: '1rem',
            }}
          >
            {delta}
          </Typography>
        </Box>

        <Box>
          <Box
            display={'flex'}
            flexDirection={'row'}
            gap={1}
            borderRadius={2}
            p={'4px'}
            sx={{
              backgroundColor: 'customBackground.section',
            }}
          >
            <AutoAwesome
              fontSize="small"
              sx={{
                color: enableDarkTheme
                  ? 'rgb(250, 204, 21)'
                  : 'rgb(202, 138, 4)',
              }}
            />
            <Box>
              <Typography
                sx={{
                  fontSize: '0.8rem',
                }}
              >
                {t('approved_plan')}
              </Typography>
              <Box display={'flex'} alignItems={'center'} gap={'2px'}>
                <Typography
                  sx={{
                    fontSize: '1rem',
                    fontWeight: 600,
                  }}
                >
                  {Number(planValue) ? `${planValue} ${planUnit}` : 'N/A'}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Stack>
    </Paper>
  );
};
